import {StyleSheet} from 'react-native';
import Typography from '../../../../../constants/Typography';
import {createModalBaseStyles} from '../../../../../styles/modalBaseStyles.shared';

export const createIndirectActivityModalStyles = (theme: any) =>
  StyleSheet.create({
    ...(createModalBaseStyles(theme) as any),

    // IndirectActivityModal-specific styles
    container: {
      flex: 1,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: theme.indirectActivityModalOverlay,
    },
    modal: {
      backgroundColor: theme.notedModalBG,
      paddingVertical: Typography.padding.padding24,
      borderColor: theme.notesModalBorder,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderRadius: Typography.radius.radius12,
      gap: Typography.gap.gap24,
      justifyContent: Typography.textAlign.centerAlign,
      maxHeight: Typography.height.height544,
      width: Typography.width.width896,
    },
    separatorLine: {
      height: Typography.height.height1,
      backgroundColor: theme.noteHeaderSeparator,
    },
    content: {
      flexDirection: 'column',
      paddingHorizontal: Typography.padding.padding24,
      //gap: Typography.gap.gap36,
      //height: Typography.height.height384,
    },
    applyToContainer: {
      gap: Typography.gap.gap8,
    },
    listContainer: {justifyContent: Typography.contentAlign.spaceBetween},
    label: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      color: theme.notesModalTitle,
    },
    subLabel: {
      fontSize: Typography.fontSize.fontSize24,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.woStatusDesc,
    },
    noteLog: {
      flexDirection: 'column',
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: theme.noteSectionBorder,
      borderRadius: Typography.radius.radius4,
      paddingVertical: Typography.padding.padding12,
      flex: 1,
      maxWidth: Typography.width.width400,
    },
    footerButtons: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.flexEnd,
      // gap: Typography.gap.gap16,
      paddingHorizontal: Typography.padding.padding24,
    },
  });